import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getMembers,
  GetMembersQueryParameters,
  resolveMembersLinks
} from "Api/organizations/member/getMembers.request";
import { OrganizationMembers } from "Api/organizations/member/Member.types";
import { resolveNextPage } from "Api/utils";

export type Props = {
  organizationId: string;
  sort?: GetMembersQueryParameters["sort"];
};

export const loadAllMembers = createAsyncThunk(
  `organization/members/loadMembers`,
  async ({ organizationId, sort: sort }: Props) => {
    let next: OrganizationMembers | undefined = await getMembers(
      organizationId,
      { sort }
    );
    let users = await resolveMembersLinks(next).users?.();
    let members = [...next.items];

    while (next) {
      next = await resolveNextPage(next);
      if (next) {
        members = members.concat(next.items);
        const nextUsers = await resolveMembersLinks(next).users?.();
        if (users && nextUsers) users = { ...users, ...nextUsers };
      }
    }

    return {
      members: { items: members, _links: {} },
      users
    };
  }
);
